import { render, staticRenderFns } from "./StoreTypeManage.vue?vue&type=template&id=1bfe3156&scoped=true"
import script from "./StoreTypeManage.vue?vue&type=script&lang=js"
export * from "./StoreTypeManage.vue?vue&type=script&lang=js"
import style0 from "./StoreTypeManage.vue?vue&type=style&index=0&id=1bfe3156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfe3156",
  null
  
)

export default component.exports